export enum TimePeriod {
  Morning = 1,
  Noon = 2,
  Evening = 3,
  Other = 4,
}
